if (!customElements.get('before-after-image')) {
  class BeforeAfterImage extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.slider');
      this.container = this.querySelector('.before-after-container');
      this.boundPointerMove = this.onPointerMove.bind(this);
      this.boundPointerUp = this.onPointerUp.bind(this);
      this.isDragging = false;
    }
  
    connectedCallback() {
      this.observeVisibility();
    }
  
    initSlider() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.container.addEventListener('transitionend', () => {
        this.container.classList.remove('transition');
        this.container.classList.remove('transition-faster');
      });

      this.slider.addEventListener('pointerdown', (event) => {
        event.preventDefault();
        this.isDragging = true;
        this.slider.setPointerCapture?.(event.pointerId);
        document.addEventListener('pointermove', this.boundPointerMove);
        document.addEventListener('pointerup', this.boundPointerUp);
      });

      this.container.addEventListener('click', (event) => {
        if (this.isDragging) return;
        this.container.classList.remove('transition');
        this.container.classList.add('transition-faster');
        this.updateSliderPosition(event.clientX);
      });

      this.slider.addEventListener('keydown', (event) => {
        const current = Number(this.slider.getAttribute('aria-valuenow')) || 50;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.updateSliderPercent(Math.max(current - 5, 0));
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.updateSliderPercent(Math.min(current + 5, 100));
        } else if (event.key === 'Home') {
          event.preventDefault();
          this.updateSliderPercent(0);
        } else if (event.key === 'End') {
          event.preventDefault();
          this.updateSliderPercent(100);
        }
      });

      this.updateSliderPercent(50);
    }

    updateSliderPosition(clientX) {
      const containerRect = this.container.getBoundingClientRect();
      const width = containerRect.width;
      let position = clientX - containerRect.left;

      if (position < 0) position = 0;
      if (position > width) position = width;

      const percent = width > 0 ? (position / width) * 100 : 50;
      this.updateSliderPercent(percent);
    }

    updateSliderPercent(percent) {
      const boundedPercent = Math.min(Math.max(percent, 0), 100);
      this.container.style.setProperty('--slider-position', `${boundedPercent}%`);
      this.container.style.setProperty('--clip-path-percent', `${boundedPercent}%`);
      this.slider.setAttribute('aria-valuenow', Math.round(boundedPercent));
    }

    onPointerMove(event) {
      this.container.classList.remove('transition');
      this.updateSliderPosition(event.clientX);
    }

    onPointerUp() {
      this.isDragging = false;
      document.removeEventListener('pointermove', this.boundPointerMove);
      document.removeEventListener('pointerup', this.boundPointerUp);
    }
  
    observeVisibility() {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.initSlider();
            observer.unobserve(this.container); 
          }
        });
      }, { threshold: 0 });
  
      observer.observe(this.container);
    }
  }
  
  customElements.define('before-after-image', BeforeAfterImage);
}
